// Dev environments may prepend HTTPOutputHandler noise before JSON bodies.
async function parseJsonResponse(response) {
    const text = await response.text();

    try {
        return JSON.parse(text);
    } catch (error) {
        const match = text.match(/\{[\s\S]*\}\s*$/);

        if (match) {
            return JSON.parse(match[0]);
        }

        throw error;
    }
}

export async function fetchFormDefinition(apiUrl) {
    const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
            Accept: "application/json",
        },
    });

    if (!response.ok) {
        throw new Error(`Failed to load form: ${response.status}`);
    }

    return parseJsonResponse(response);
}

export async function submitForm(submitUrl, payload) {
    const response = await fetch(submitUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        body: JSON.stringify(payload),
    });

    let data = {};

    try {
        data = await parseJsonResponse(response);
    } catch (error) {
        console.error("Contact popup: invalid JSON response", error);
    }

    return {
        ok: response.ok,
        status: response.status,
        data,
    };
}
